/**
 * Cart drawer + Ajax Cart API wiring.
 * Re-renders sections/cart-drawer.liquid via the Section Rendering API after every
 * mutation so markup (empty state, free-shipping bar, totals, recommendations slot)
 * always matches the server, then re-initializes the vendor JS (Swiper) inside it.
 */
(function () {
  'use strict';

  var routes = (window.themeVars && window.themeVars.routes) || {};

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function updateCartCountBadges(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      if (el.closest('.number-order')) {
        el.textContent = ('00' + count).slice(-2);
      } else if (el.textContent.trim().indexOf('(') === 0) {
        el.textContent = '(' + ('00' + count).slice(-2) + ')';
      } else {
        el.textContent = count;
      }
    });
  }

  function fetchSection(sectionId) {
    return fetch(routes.cartUrl + '?section_id=' + sectionId)
      .then(function (res) { return res.text(); });
  }

  function refreshCartDrawer() {
    return fetchSection('cart-drawer').then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('#shoppingCart');
      var oldDrawer = qs('#shoppingCart');
      if (newDrawer && oldDrawer) {
        // Update content in place rather than replacing the node: replaceWith()
        // destroys Bootstrap's Offcanvas instance (and its show/backdrop state),
        // which is bound to this specific element, causing broken layout/sizing
        // on the very next open.
        oldDrawer.innerHTML = newDrawer.innerHTML;
        bindCartDrawerEvents();
        loadCartRecommendations();
      }
      return fetch('/cart.js');
    }).then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCountBadges(cart.item_count);
      })
      .catch(function () {});
  }

  function loadCartRecommendations() {
    var mount = qs('#cart-drawer-recommendations');
    if (!mount || !routes.productRecommendations) return;
    var productId = mount.getAttribute('data-product-id');
    if (!productId) return;
    var url = routes.productRecommendations + '?section_id=cart-drawer-recommendations&product_id=' + productId + '&limit=4&intent=related';
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var content = doc.querySelector('[id^="shopify-section-"]');
        if (content) {
          mount.innerHTML = content.innerHTML;
          if (window.jQuery && window.Swiper) {
            initRecommendationSwiper();
          }
        }
      })
      .catch(function () {});
  }

  function initRecommendationSwiper() {
    qsa('.al-swiper', qs('#cart-drawer-recommendations')).forEach(function (el) {
      if (el.swiper) return;
      new window.Swiper(el, {
        slidesPerView: 2,
        spaceBetween: 16,
        grabCursor: true
      });
    });
  }

  // TEMPORARY: redirect straight to the cart page after adding, instead of
  // opening the cart drawer. Requested as a stand-in until a cart/upsell app
  // is installed to handle that experience instead. To go back to the drawer
  // behavior later, set this to false (or delete this flag and the branch
  // below that uses it).
  var REDIRECT_TO_CART_PAGE_ON_ADD = true;

  function addToCart(variantId, quantity, button, opts) {
    if (!variantId) return;
    opts = opts || {};
    if (button) button.classList.add('is-loading');
    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var err = new Error(data.description || 'Could not add item to cart.');
            err.data = data;
            throw err;
          }
          return data;
        });
      })
      .then(function (data) {
        // opts.onSuccess lets a caller (e.g. the product page) update its own
        // UI in place instead of the default redirect/drawer behavior below.
        // /cart/add.js only returns the added line item, not the cart totals,
        // so fetch /cart.js separately to refresh the header cart-count badge.
        if (opts.onSuccess) {
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) { updateCartCountBadges(cart.item_count); })
            .catch(function () {});
          opts.onSuccess(data);
          return;
        }
        if (REDIRECT_TO_CART_PAGE_ON_ADD) {
          window.location.href = routes.cartUrl;
          return;
        }
        return refreshCartDrawer().then(function () {
          var drawer = qs('#shoppingCart');
          if (drawer && window.bootstrap) {
            var instance = window.bootstrap.Offcanvas.getOrCreateInstance(drawer);
            instance.show();
          }
        });
      })
      .catch(function (err) {
        window.alert(err.message || 'Could not add item to cart.');
      })
      .finally(function () {
        if (button) button.classList.remove('is-loading');
      });
  }

  // Buy Now = make sure this variant is in the cart (at least `quantity` of
  // it), then go to checkout. If it's already there, pressing Buy Now must not
  // add another unit every time, so only add when missing / top up when short.
  function buyNow(variantId, quantity, button) {
    if (!variantId) return;
    quantity = quantity || 1;
    if (button) button.classList.add('is-loading');

    function parse(res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Could not start checkout.');
        return data;
      });
    }
    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(parse);
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(parse)
      .then(function (cart) {
        var line = cart.items.filter(function (item) {
          return String(item.variant_id) === String(variantId);
        })[0];
        if (!line) return post(routes.cartAdd, { id: variantId, quantity: quantity });
        if (line.quantity < quantity) return post(routes.cartChange, { id: line.key, quantity: quantity });
      })
      .then(function () {
        window.location.href = routes.checkoutUrl;
      })
      .catch(function (err) {
        window.alert(err.message || 'Could not start checkout.');
        if (button) button.classList.remove('is-loading');
      });
  }

  // Product-card quantity stepper: shown in place of the Add to Cart button
  // once an item is already in the cart, so shoppers can adjust quantity
  // straight from a collection/search grid without opening the cart.
  function changeCardQty(wrap, quantity) {
    var key = wrap.getAttribute('data-line-item-key');
    if (!key) return;
    var input = qs('.js-card-qty-input', wrap);
    wrap.classList.add('is-loading');
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCountBadges(cart.item_count);
        if (quantity <= 0) {
          var addBtn = wrap.parentNode.querySelector('.js-add-to-cart');
          wrap.classList.add('d-none');
          wrap.setAttribute('data-line-item-key', '');
          if (addBtn) addBtn.classList.remove('d-none');
        } else if (input) {
          input.value = quantity;
        }
      })
      .catch(function () {})
      .finally(function () {
        wrap.classList.remove('is-loading');
      });
  }

  function changeLineItem(key, quantity) {
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { return refreshCartDrawer(); });
  }

  function updateNote(note) {
    fetch(routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note })
    }).then(function () { return refreshCartDrawer(); });
  }

  function applyDiscount(code) {
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routes.cartUrl || '/cart');
  }

  function estimateShipping(form) {
    var zip = qs('#zipcode', form).value;
    var country = qs('#shipping-country-form', form).value;
    var province = qs('#shipping-province-form', form).value;
    var messageEl = qs('#zipcode-message', form);
    var successEl = qs('#zipcode-success', form);
    var resultEl = qs('[data-shipping-result]', form);

    var url = '/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(zip) +
      '&shipping_address[country]=' + encodeURIComponent(country) +
      '&shipping_address[province]=' + encodeURIComponent(province);

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('no rates');
        return res.json();
      })
      .then(function (data) {
        if (!data.shipping_rates || !data.shipping_rates.length) throw new Error('no rates');
        var rate = data.shipping_rates[0];
        if (resultEl) resultEl.textContent = rate.name + ' — ' + (rate.price / 100).toFixed(2);
        if (messageEl) messageEl.style.display = 'none';
        if (successEl) successEl.style.display = '';
      })
      .catch(function () {
        if (successEl) successEl.style.display = 'none';
        if (messageEl) messageEl.style.display = '';
      });
  }

  function populateProvinces(countrySelect, provinceSelect) {
    var selected = countrySelect.options[countrySelect.selectedIndex];
    var provinces = [];
    try {
      provinces = JSON.parse(selected.getAttribute('data-provinces') || '[]');
    } catch (e) {}
    provinceSelect.innerHTML = '';
    provinces.forEach(function (name) {
      var opt = document.createElement('option');
      opt.value = name;
      opt.textContent = name;
      provinceSelect.appendChild(opt);
    });
    provinceSelect.closest('.al-field').style.display = provinces.length ? '' : 'none';
  }

  function bindCartDrawerEvents() {
    var drawer = qs('#shoppingCart');
    if (!drawer) return;

    qsa('.js-cart-remove', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-line-item-key]');
        changeLineItem(item.getAttribute('data-line-item-key'), 0);
      });
    });

    qsa('.js-cart-qty-minus', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-line-item-key]');
        var input = qs('.js-cart-qty-input', item);
        var qty = Math.max(0, parseInt(input.value, 10) - 1);
        changeLineItem(item.getAttribute('data-line-item-key'), qty);
      });
    });

    qsa('.js-cart-qty-plus', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-line-item-key]');
        var input = qs('.js-cart-qty-input', item);
        var qty = parseInt(input.value, 10) + 1;
        changeLineItem(item.getAttribute('data-line-item-key'), qty);
      });
    });

    qsa('.js-cart-qty-input', drawer).forEach(function (input) {
      input.addEventListener('change', function () {
        var item = input.closest('[data-line-item-key]');
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        changeLineItem(item.getAttribute('data-line-item-key'), qty);
      });
    });

    var noteForm = qs('.js-cart-note-form', drawer);
    if (noteForm) {
      noteForm.addEventListener('submit', function (e) {
        e.preventDefault();
        updateNote(qs('textarea[name="note"]', noteForm).value);
      });
    }

    var discountForm = qs('.js-cart-discount-form', drawer);
    if (discountForm) {
      discountForm.addEventListener('submit', function (e) {
        e.preventDefault();
        applyDiscount(qs('#discount-code', discountForm).value);
      });
    }

    var shippingForm = qs('.js-shipping-estimate-form', drawer);
    if (shippingForm) {
      var countrySelect = qs('#shipping-country-form', shippingForm);
      var provinceSelect = qs('#shipping-province-form', shippingForm);
      if (countrySelect && provinceSelect) {
        populateProvinces(countrySelect, provinceSelect);
        countrySelect.addEventListener('change', function () {
          populateProvinces(countrySelect, provinceSelect);
        });
      }
      shippingForm.addEventListener('submit', function (e) {
        e.preventDefault();
        estimateShipping(shippingForm);
      });
    }
  }

  // Bound to window (not document), capture phase: Bootstrap's own delegated
  // [data-bs-toggle="offcanvas"] handler is also registered on document in the
  // capture phase (see bootstrap.min.js), and since bootstrap.min.js loads
  // before this file, its listener would otherwise always fire first (open the
  // drawer) before this one gets to redirect. window precedes document in the
  // capture chain, so a capture listener there always runs first regardless of
  // script load order.
  window.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.js-add-to-cart');
    if (addBtn) {
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-variant-id');
      addToCart(variantId, 1, addBtn);
      return;
    }

    var buyBtn = e.target.closest('.js-buy-now');
    if (buyBtn) {
      e.preventDefault();
      var buyVariantId = buyBtn.getAttribute('data-variant-id');
      buyNow(buyVariantId, 1, buyBtn);
      return;
    }

    var cardQtyBtn = e.target.closest('.js-card-qty-minus, .js-card-qty-plus');
    if (cardQtyBtn) {
      e.preventDefault();
      var qtyWrap = cardQtyBtn.closest('.js-card-qty');
      var qtyInput = qtyWrap && qs('.js-card-qty-input', qtyWrap);
      if (!qtyWrap || !qtyInput) return;
      var currentQty = parseInt(qtyInput.value, 10) || 0;
      var nextQty = cardQtyBtn.classList.contains('js-card-qty-plus') ? currentQty + 1 : currentQty - 1;
      if (nextQty < 0) nextQty = 0;
      changeCardQty(qtyWrap, nextQty);
      return;
    }

    // Same temporary preference as REDIRECT_TO_CART_PAGE_ON_ADD above: while
    // no cart/upsell app is installed, the header/mobile-menu cart icon goes
    // straight to the cart page instead of opening the drawer. Revert by
    // setting REDIRECT_TO_CART_PAGE_ON_ADD to false (this reuses that flag).
    if (REDIRECT_TO_CART_PAGE_ON_ADD) {
      var cartIconLink = e.target.closest('a[href="#shoppingCart"]');
      if (cartIconLink) {
        // stopPropagation (plus capture: true below) keeps this click from ever
        // reaching Bootstrap's own document-level offcanvas toggle handler, which
        // otherwise opens the drawer for a frame before this redirect fires.
        e.preventDefault();
        e.stopPropagation();
        window.location.href = routes.cartUrl;
      }
    }
  }, true);

  function changeLineItemAndReload(key, quantity) {
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { window.location.reload(); });
  }

  function bindCartPageEvents() {
    var table = qs('.al-table-page-cart');
    if (!table) return;

    qsa('.js-cart-qty-minus', table).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-line-item-key]');
        var input = qs('.js-cart-qty-input', item);
        changeLineItemAndReload(item.getAttribute('data-line-item-key'), Math.max(0, parseInt(input.value, 10) - 1));
      });
    });
    qsa('.js-cart-qty-plus', table).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-line-item-key]');
        var input = qs('.js-cart-qty-input', item);
        changeLineItemAndReload(item.getAttribute('data-line-item-key'), parseInt(input.value, 10) + 1);
      });
    });
    qsa('.js-cart-qty-input', table).forEach(function (input) {
      input.addEventListener('change', function () {
        var item = input.closest('[data-line-item-key]');
        changeLineItemAndReload(item.getAttribute('data-line-item-key'), Math.max(0, parseInt(input.value, 10) || 0));
      });
    });
    qsa('.js-cart-remove', table).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-line-item-key]');
        changeLineItemAndReload(item.getAttribute('data-line-item-key'), 0);
      });
    });

    var noteEl = qs('.js-cart-note');
    if (noteEl) {
      noteEl.addEventListener('change', function () { updateNote(noteEl.value); });
    }

    var discountForm = qs('[data-cart-page-discount]');
    if (discountForm) {
      discountForm.addEventListener('submit', function (e) {
        e.preventDefault();
        applyDiscount(qs('input[name="discount"]', discountForm).value);
      });
    }
  }

  function loadRelatedProductSections() {
    qsa('[data-section-id="related-products"]').forEach(function (mount) {
      var productId = mount.getAttribute('data-product-id');
      if (!productId || !routes.productRecommendations) return;
      fetch(routes.productRecommendations + '?section_id=related-products&product_id=' + productId + '&limit=4')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var content = doc.querySelector('[id^="shopify-section-"]');
          if (content) mount.innerHTML = content.innerHTML;
        })
        .catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindCartDrawerEvents();
    loadCartRecommendations();
    bindCartPageEvents();
    loadRelatedProductSections();
  });

  window.themeCart = {
    addToCart: addToCart,
    buyNow: buyNow,
    refresh: refreshCartDrawer,
    updateCartCountBadges: updateCartCountBadges,
    routes: routes
  };
})();
